export const OrganizationActionType = {
  LOAD_LIST_START: 'org/LOAD_LIST_START',
  LOAD_LIST_SUCCESS: 'org/LOAD_LIST_SUCCESS',
  LOAD_LIST_FAILURE: 'org/LOAD_LIST_FAILURE',
  SET_SELECTED: 'org/SET_SELECTED',
  CLEAR_SELECTED: 'org/CLEAR_SELECTED',
  MUTATION_START: 'org/MUTATION_START',
  MUTATION_END: 'org/MUTATION_END',
  CREATE_SUCCESS: 'org/CREATE_SUCCESS',
  UPDATE_SUCCESS: 'org/UPDATE_SUCCESS',
  DELETE_SUCCESS: 'org/DELETE_SUCCESS',
  SET_ERROR: 'org/SET_ERROR',
  CLEAR_ERROR: 'org/CLEAR_ERROR',
}

export function createInitialOrganizationState() {
  return {
    organizations: [],
    listTotal: 0,
    listPage: 1,
    listLimit: 50,
    listSummary: null,
    selectedOrganization: null,
    listLoading: false,
    mutationLoading: false,
    error: null,
  }
}

export function organizationReducer(state, action) {
  switch (action.type) {
    case OrganizationActionType.LOAD_LIST_START:
      return { ...state, listLoading: true, error: null }
    case OrganizationActionType.LOAD_LIST_SUCCESS: {
      const payload = action.payload
      const nextOrgs = Array.isArray(payload) ? payload : payload.items ?? []
      const sel = state.selectedOrganization
      const nextSelected = sel ? nextOrgs.find((o) => o.id === sel.id) ?? null : null
      return {
        ...state,
        organizations: nextOrgs,
        listTotal: Array.isArray(payload) ? payload.length : payload.total ?? nextOrgs.length,
        listPage: Array.isArray(payload) ? 1 : payload.page ?? 1,
        listLimit: Array.isArray(payload) ? nextOrgs.length : payload.limit ?? 50,
        listSummary: Array.isArray(payload) ? null : payload.summary ?? null,
        listLoading: false,
        selectedOrganization: nextSelected,
      }
    }
    case OrganizationActionType.LOAD_LIST_FAILURE:
      return { ...state, listLoading: false, error: action.payload }
    case OrganizationActionType.SET_SELECTED:
      return { ...state, selectedOrganization: action.payload }
    case OrganizationActionType.CLEAR_SELECTED:
      return { ...state, selectedOrganization: null }
    case OrganizationActionType.MUTATION_START:
      return { ...state, mutationLoading: true, error: null }
    case OrganizationActionType.MUTATION_END:
      return { ...state, mutationLoading: false }
    case OrganizationActionType.CREATE_SUCCESS:
      return {
        ...state,
        organizations: [action.payload, ...state.organizations],
        mutationLoading: false,
      }
    case OrganizationActionType.UPDATE_SUCCESS: {
      const updated = action.payload
      return {
        ...state,
        organizations: state.organizations.map((o) => (o.id === updated.id ? updated : o)),
        selectedOrganization:
          state.selectedOrganization?.id === updated.id ? updated : state.selectedOrganization,
        mutationLoading: false,
      }
    }
    case OrganizationActionType.DELETE_SUCCESS: {
      const id = action.payload
      return {
        ...state,
        organizations: state.organizations.filter((o) => o.id !== id),
        selectedOrganization: state.selectedOrganization?.id === id ? null : state.selectedOrganization,
        mutationLoading: false,
      }
    }
    case OrganizationActionType.SET_ERROR:
      return { ...state, error: action.payload, listLoading: false, mutationLoading: false }
    case OrganizationActionType.CLEAR_ERROR:
      return { ...state, error: null }
    default:
      return state
  }
}
